












import { Component, Vue } from 'vue-property-decorator';
import Search from './components/Search.vue';
import List from './components/List.vue';
import Map from './components/map/Map.vue';

@Component({
  components: {
    List, Search, Map
  },
})
export default class App extends Vue {
  get view() {
    return this.$store.getters.view;
  }
  mounted() {
    this.$store.dispatch('fetchPlaces');
  }
}
